import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';

// Bands are tiled every 143px (viewBox units). The loop must advance a whole
// number of bands that realigns BOTH the default 2-color gray pattern and the
// 5-color hover pattern, so it steps LCM(2,5)=10 bands (1430) per cycle.
const PERIOD = 1430;

export default class VisionWaves extends Component {
	constructor() {
		super({
			element: '.vision',
			elements: {
				waves: '.vision__waves',
				item: '.vision__gallery-item--waves',
			},
		});

		this.onEnter = () => this.tween?.timeScale(2);
		this.onLeave = () => this.tween?.timeScale(1);
	}

	create() {
		super.createComponent();
		if (!this.elements.waves) return;

		this.tween = GSAP.to(this.elements.waves, {
			x: PERIOD,
			duration: 25,
			ease: 'none',
			repeat: -1,
		});

		this.addEventListeners();
	}

	addEventListeners() {
		this.elements.item?.addEventListener('mouseenter', this.onEnter);
		this.elements.item?.addEventListener('mouseleave', this.onLeave);
	}

	removeEventListeners() {
		this.elements.item?.removeEventListener('mouseenter', this.onEnter);
		this.elements.item?.removeEventListener('mouseleave', this.onLeave);
	}

	destroy() {
		this.removeEventListeners();
		this.tween?.kill();
		super.destroy();
	}
}
